import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useLanguage } from "../context/LanguageContext";
import { prefetchPublicRoute } from "../lib/prefetchPublicRoute";

export const usePrefetchPublicRoute = () => {
  const queryClient = useQueryClient();
  const { language } = useLanguage();

  return useCallback(
    (pathname) => {
      prefetchPublicRoute(queryClient, pathname, language);
    },
    [queryClient, language]
  );
};
